<template>
  <div class="form-employment">
    <b-row>
      <b-col v-for="col in columnsTop" :key="col.field" md="4">
        <validation-observer :ref="`simpleRules${col.field}`">
          <validation-provider
            #default="{ errors }"
            :name="col.label"
            :rules="col.formOption ? col.formOption.rules : ''"
          >
            <div
              v-if="col.auditing"
              style="padding-left:15px;display:inline-block;"
            >
              <label :class="{ required: hasRequired(col.formOption) }"
                >{{ col.label }}:</label
              ><br />
              <b-badge
                v-b-tooltip.hover.focus.v-primary
                variant="primary"
                class="cursor-pointer"
                :title="
                  `${col.auditData.createStaff.realName}: ${col.auditData.createTime}`
                "
              >
                <span>
                  {{
                    col.auditData.oldDataName
                      ? col.auditData.oldDataName
                      : col.auditData.oldData
                  }}
                </span>
                <feather-icon icon="ArrowRightIcon" size="20" />
                <span class="text-warning">
                  {{
                    col.auditData.newDataName
                      ? col.auditData.newDataName
                      : col.auditData.newData
                  }}
                </span>
              </b-badge>
            </div>
            <div
              v-else-if="col.disabled || disabled"
              style="padding-left:15px;display:inline-block;"
            >
              <label
                class="mcc-form-label"
                :class="{ required: hasRequired(col.formOption) }"
                >{{ col.label }}:</label
              ><br />
              <p class="text-primary">
                {{ form[col.dictField ? col.dictField : col.field] }}
              </p>
            </div>
            <form-item
              v-else
              :form-label="col.label"
              :required="hasRequired(col.formOption)"
              :form-value="form[col.dictField ? col.dictField : col.field]"
              @saveFormItem="update($event, col.field)"
              @clearFormItem="clearFormItem"
            >
              <template slot="labelSmall">
                <small class="text-danger">{{ errors[0] }}</small>
              </template>
              <element-component
                :id="`v-add-${col.field}`"
                v-model="form[col.field]"
                :state="errors.length > 0 ? false : null"
                :label="col.label"
                :option="col.formOption"
                :disabled="col.disabled"
              />
            </form-item>
          </validation-provider>
        </validation-observer>
      </b-col>
    </b-row>
    <!-- 只有hr角色切转正的才可以查看医疗卡pdf -->
    <div
      style="padding-left: 16px;"
      v-if="
        userAllInfo.staffInfo.status === 1 &&
          userAllInfo.roleId.split(',').includes('1123598816738675203')
      "
    >
      <p>Medical E-Card</p>
      <feather-icon
        icon="FileIcon"
        class="text-primary cursor-pointer ml-1"
        size="20"
        @click="openPdf"
      />
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ElementComponent from '@/components/elementComponent.vue'
import FormItem from '@/components/FormItem.vue'
import { benefit } from '@/api/staff/index'
import { getList } from '@/api/system/param'
import { BFormInput, BCol, BRow, BBadge, VBTooltip } from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import getColumn from './option/benefit'
import { mapGetters } from 'vuex'
export default {
  components: {
    FormItem,
    BCol,
    BRow,
    ElementComponent,
    ValidationProvider,
    ValidationObserver,
    BBadge,
    FormItem,
    BCol,
    BRow,
    ElementComponent,
    ValidationProvider,
    ValidationObserver,
    BBadge,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    // 修改刷新的回调
    refreshChange: {
      type: Function,
      default: (done) => {
        done()
      },
    },
    auditData: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    staffId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 需要number转string的类型
      hasToStringTypes: ['select'],
      pdfUrl: '',
    }
  },
  mounted() {
    getList(1, 10, { paramKey: 'staff_confirmation_guide_pdfUrl' }).then(
      (res) => {
        console.log(res)
        this.pdfUrl = res?.data?.data?.records[0]?.paramValue || ''
      }
    )
  },
  computed: {
    ...mapGetters(['userAllInfo']),
    // columnsTop() {
    //   const columns = getColumn()
    //   const result = []
    //   columns.forEach(col => {
    //     const param = col
    //     if (Array.isArray(this.auditData)) {
    //       this.auditData.forEach(item => {
    //         if (col.field === item.field) {
    //           param.auditing = true
    //           param.auditData = item
    //         }
    //       })
    //     }
    //     result.push(param)
    //   })
    //   return result
    // },
    columnsTop() {
      const columns = getColumn()
      return columns
    },
    form() {
      const res = this.data
      const cols = [this.columnsTop]
      for (let i = 0; i < cols.length; i += 1) {
        const element = cols[i]
        element.forEach((item) => {
          const val = res[item.field]
          if (val || val === 0) {
            const formatVal =
              this.hasToStringTypes.indexOf(item.type) !== -1
                ? val.toString()
                : val
            res[item.field] = formatVal
          }
        })
      }
      return res
    },
  },
  methods: {
    // 国际化
    i18n(param) {
      return this.$t(`_staff.${param}`)
    },
    update(done, key) {
      this.$refs[`simpleRules${key}`][0].validate().then((success) => {
        if (success) {
          const params = {
            id: this.form.id,
            staffId: this.staffId,
          }
          params[key] = this.form[key] || ''
          benefit.submit(params).then((res) => {
            let isDone = false
            const refreshDone = () => {
              if (!isDone) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: this.$t('_default.toast.title'),
                    icon: 'BellIcon',
                    text: this.$t('_default.toast.text.success'),
                    variant: 'success',
                  },
                })
                done()
                isDone = true
              }
            }
            this.refreshChange(refreshDone)
          })
        }
      })
    },
    hasRequired(option = {}) {
      const rules = option.rules || ''
      return rules.indexOf('required') !== -1
    },
    openPdf() {
      console.log('sssss')
      window.open(this.pdfUrl)
    },
  },
}
</script>

<style lang="scss" scoped>
.form-employment {
  &-line {
    width: 100%;
    border-bottom: 1px solid #cad6eb;
    margin-bottom: 1rem;
  }
  &-body {
    display: flex;
    &__left {
      width: 68%;
    }
    &__right {
      width: 32%;
      position: relative;
    }
  }
}
</style>
